import {Box, Typography} from '@viptech/react-components'
import {useNavigate} from 'react-router-dom'
import LogoIcon from 'src/images/logos/brain-default/LoginPagesLogo.svg'
import {CancelAndGoBackButton, ListFeddback, LoginBox, Logo} from '../Styles'
import EmailCountdownButton from './EmailCountdownButton'

type FeedbackForgotPasswordProps = {
  success: boolean
  email: string
  resendFunction: () => void
  tryAnotherEmail: () => void
  errorMessage?: string
}

export default function FeedbackForgotPassword({success, email, resendFunction, tryAnotherEmail, errorMessage}: FeedbackForgotPasswordProps) {
  const navigate = useNavigate()

  const TitleAndText = ({title, text}: {title: string; text: string}) => {
    return (
      <Box display='flex' direction='column' rowGap='10px'>
        <Typography variant='label' color={'#F2F4F7'} size='22px'>
          {title}
        </Typography>
        <Box>
          <Typography variant='label' color={'#F2F4F7'} size='16px'>
            {text}
          </Typography>
          <Typography variant='label' weight={700} color={'#F2F4F7'} size='16px'>
            {email}
          </Typography>
        </Box>
      </Box>
    )
  }

  const TextAuxiliary = () => {
    return (
      <Box display='flex' direction='column' align='flex-start' rowGap='10px' width='100%'>
        {success ? (
          <>
            <Typography variant='label' color={'#F2F4F7'} size='16px'>
              Não encontrou o e-mail?
            </Typography>
            <ul>
              <ListFeddback>Verifique também a sua caixa de spam ou lixo eletrônico.</ListFeddback>
              <ListFeddback>Caso não receba em alguns minutos, você pode solicitar o reenvio abaixo.</ListFeddback>
            </ul>

            <Typography variant='label' color={'#F2F4F7'} size='16px'>
              Assim que receber, siga as instruções do e-mail para criar uma nova senha.
            </Typography>
          </>
        ) : (
          <Typography variant='label' color={'#F2F4F7'} size='16px'>
            {errorMessage ?? 'Informe outro e-mail e tente novamente'}
          </Typography>
        )}
      </Box>
    )
  }

  const handleNavigate = () => {
    if (success) navigate('/login')
    else tryAnotherEmail()
  }
  return (
    <LoginBox>
      <Logo src={LogoIcon} />
      <TitleAndText
        title={success ? 'E-mail enviado com sucesso ' : 'E-mail não enviado'}
        text={success ? 'Enviamos um e-mail de recuperação de senha para: ' : 'Não foi possível enviar sua solicitação para: '}
      />
      <TextAuxiliary />
      <CancelAndGoBackButton onClick={() => handleNavigate()}>{success ? 'Voltar para o login' : 'Informar outro e-mail'}</CancelAndGoBackButton>
      {success && <EmailCountdownButton seconds={30} onClick={() => resendFunction()} />}
    </LoginBox>
  )
}
